"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IssueType = void 0;
var IssueType;
(function (IssueType) {
    IssueType["Issue"] = "issue";
    IssueType["Crash"] = "crash";
    IssueType["Feedback"] = "user-feedback";
})(IssueType = exports.IssueType || (exports.IssueType = {}));
